// extracted by mini-css-extract-plugin
export default {"mealMagic":"Navbar_mealMagic__nS3xr","chefLogo":"Navbar_chefLogo__gi8iJ"};